import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { CURRICULUM } from "../../lib/site";

export default function Curriculum() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <Section id="curriculum" bg="bg-brand-cream">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#0B31EB">Curriculum</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          Your Complete YouTube Lead Generation Roadmap
        </h2>
        <p className="text-base sm:text-lg text-brand-ink/75 mt-5">
          The curriculum is organized by transformation stages, so you understand what to build first and what comes next.
        </p>
      </Reveal>

      <div className="mt-12 space-y-4">
        {CURRICULUM.map((c, i) => {
          const active = openIdx === i;
          return (
            <Reveal key={c.n} delay={(i % 4) * 0.04}>
              <div
                className={`rounded-[22px] border-2 border-brand-black overflow-hidden transition-shadow duration-200 ${
                  active ? "bg-white" : "bg-white/60"
                }`}
                style={{ boxShadow: active ? "8px 10px 0 #0B31EB" : "none" }}
              >
                <button
                  onClick={() => setOpenIdx(active ? -1 : i)}
                  data-testid={`curriculum-toggle-${i}`}
                  aria-expanded={active}
                  className="w-full flex items-center gap-4 sm:gap-6 p-5 sm:p-6 text-left"
                >
                  <span className={`font-display text-2xl sm:text-3xl shrink-0 ${active ? "text-brand-blue" : "text-brand-ink/25"}`}>{c.n}</span>
                  <span className="font-display text-lg sm:text-2xl flex-1">{c.t}</span>
                  <span className="h-9 w-9 rounded-full border-2 border-brand-black flex items-center justify-center shrink-0 bg-brand-cream">
                    {active ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {active && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }} className="overflow-hidden">
                      <p className="px-5 sm:px-6 pb-6 pl-[68px] sm:pl-[92px] text-sm sm:text-base text-brand-ink/75 leading-relaxed">{c.d}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}
